document.addEventListener('click', function (e) {
  const btn = e.target.closest('.sf-faq-simple__question');
  if (!btn) return;

  const item = btn.closest('.sf-faq-simple__item');
  const section = btn.closest('.sf-faq-simple');
  const content = item.querySelector('.sf-faq-simple__answer');

  const isOpen = item.classList.contains('is-open');

  if (section.dataset.singleOpen) {
    section.querySelectorAll('.sf-faq-simple__item.is-open').forEach(openItem => {
      if (openItem !== item) closeItem(openItem);
    });
  }

  isOpen ? closeItem(item) : openItem(item);

  function openItem(el) {
    const body = el.querySelector('.sf-faq-simple__answer');
    el.classList.add('is-open');
    body.style.height = body.scrollHeight + 'px';

    body.addEventListener('transitionend', function handler() {
      body.style.height = 'auto';
      body.removeEventListener('transitionend', handler);
    });
  }

  function closeItem(el) {
    const body = el.querySelector('.sf-faq-simple__answer');
    body.style.height = body.scrollHeight + 'px';
    requestAnimationFrame(() => body.style.height = '0px');
    el.classList.remove('is-open');
  }
});
document.addEventListener('keydown', function (e) {
  const btn = e.target.closest('.sf-faq-simple__question');
  if (!btn) return;

  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    btn.click();
  }
});
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.sf-faq-simple');

  if (!('IntersectionObserver' in window)) {
    sections.forEach(section => section.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15
  });

  sections.forEach(section => observer.observe(section));
});
